import { ROOT_SLICE } from './constants';

export const selectRootSlice = stateAdmin => stateAdmin[ROOT_SLICE];

export const selectData = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { data } = slice;
	return data;
};

export const selectBoolMap = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { boolMap } = slice;
	return boolMap;
};

export const selectMatchTermMap = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { matchTermMap } = slice;
	return matchTermMap;
};

export const selectMatchTerm = (stateAdmin, { customer = '' }) => {
	const matchTermMap = selectMatchTermMap(stateAdmin);
	return matchTermMap[customer];
};

export const selectIsLoading = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = stateAdmin => {
	const slice = selectRootSlice(stateAdmin);
	const { errorMessage } = slice;
	return errorMessage;
};

export const selectDomain = (stateAdmin, { customer }) => {
	const slice = selectRootSlice(stateAdmin);
	const { domainMap = {} } = slice;
	return domainMap[customer];
};

export default {
	selectData,
	selectBoolMap,
	selectMatchTermMap,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage,
	selectDomain
};
